import {
    provideHttpClient,
    withInterceptors,
    withXhr,
} from '@angular/common/http';
import {
    EnvironmentProviders,
    importProvidersFrom,
    inject,
    provideEnvironmentInitializer,
    Provider,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { HippoConfig } from '@hippo/services/config';
import { HIPPO_CONFIG } from '@hippo/services/config/config.constants';
import { HippoConfirmationService } from '@hippo/services/confirmation';
import {
    hippoLoadingInterceptor,
    HippoLoadingService,
} from '@hippo/services/loading';
import { HippoMediaWatcherService } from '@hippo/services/media-watcher';
import { HippoPlatformService } from '@hippo/services/platform';
import { HippoSplashScreenService } from '@hippo/services/splash-screen';
import { HippoUtilsService } from '@hippo/services/utils';

export type HippoProviderConfig = {
    mockApi?: {
        delay?: number;
        services?: any[];
    };
    hippo?: HippoConfig;
};

/**
 * Hippo provider
 */
export const provideHippo = (
    config: HippoProviderConfig
): Array<Provider | EnvironmentProviders> => {
    // Base providers
    const providers: Array<Provider | EnvironmentProviders> = [
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill',
            },
        },
        {
            provide: HIPPO_CONFIG,
            useValue: config?.hippo ?? {},
        },

        importProvidersFrom(MatDialogModule),
        provideEnvironmentInitializer(() => inject(HippoConfirmationService)),

        provideHttpClient(
            withXhr(),
            withInterceptors([hippoLoadingInterceptor])
        ),
        provideEnvironmentInitializer(() => inject(HippoLoadingService)),

        provideEnvironmentInitializer(() => inject(HippoMediaWatcherService)),
        provideEnvironmentInitializer(() => inject(HippoPlatformService)),
        provideEnvironmentInitializer(() => inject(HippoSplashScreenService)),
        provideEnvironmentInitializer(() => inject(HippoUtilsService)),
    ];

    // Return the providers
    return providers;
};
